module.exports = "/static/assets/1364db7a0b3dfd6629ffc48f00a4f2d2.png";